import type { ReactNode } from "react";
import { PrivyProvider } from "@privy-io/react-auth";
import { createSolanaRpc, createSolanaRpcSubscriptions } from "@solana/kit";
import {
  EVM_CHAIN,
  SOLANA_CAIP,
  SOLANA_HTTP,
  SOLANA_WS,
} from "./config";

const appId = import.meta.env.VITE_PRIVY_APP_ID as string | undefined;

export function PrivyProviders({ children }: { children: ReactNode }) {
  if (!appId) {
    return (
      <div className="screen">
        <h1>Missing config</h1>
        <p className="muted">
          Set <code>VITE_PRIVY_APP_ID</code> in <code>.env</code>.
        </p>
      </div>
    );
  }

  return (
    <PrivyProvider
      appId={appId}
      config={{
        appearance: {
          theme: "dark",
          accentColor: "#14F195",
          logo: "https://multichain-tg-login.pages.dev/favicon.ico",
          walletChainType: "ethereum-and-solana",
          landingHeader: " ",
          loginMessage: " ",
        },
        loginMethods: ["telegram"],
        defaultChain: EVM_CHAIN,
        supportedChains: [EVM_CHAIN],
        embeddedWallets: {
          ethereum: {
            createOnLogin: "off",
          },
          solana: {
            createOnLogin: "off",
          },
          showWalletUIs: false,
        },
        solana: {
          rpcs: {
            [SOLANA_CAIP]: {
              rpc: createSolanaRpc(SOLANA_HTTP),
              rpcSubscriptions: createSolanaRpcSubscriptions(SOLANA_WS),
            },
          },
        } as never,
      }}
    >
      {children}
    </PrivyProvider>
  );
}
